import React, { useState, useEffect } from "react";
import { faPen, faTrash, faBan, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Avatar from 'react-avatar';
import NoAvatar from "../../../../assets/images/no-avatar.png";
import Modal from "../../../Modal";
import EditUserForm from "../EditUserForm";
import AddUserForm from "../AddUserForm";
import { getAvatarApi, activateUserApi, deleteUserApi } from "../../../../api/user";
import { getAccessTokenApi } from "../../../../api/auth";
import { errorModal, successModal } from '../../../Alerts/Alerts';
import Swal from 'sweetalert2';

import "./ListUsers.scss";

export default function ListUsers(props) {
    const { usersActive, usersInactive, setReloadUsers } = props;
    const [viewUsersActives, setViewUsersActives] = useState(true);
    const [isVisibleModal, setIsVisibleModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalContent, setModalContent] = useState(null);

    const addUserModal = () => {
        setIsVisibleModal(true);
        setModalTitle("Crear nuevo usuario");
        setModalContent(
            <AddUserForm setIsVisibleModal={setIsVisibleModal} setReloadUsers={setReloadUsers} />
        )
    }

    return (
        <>
            <div className="list-users">
                <div className="list-users__header">
                    <div className="list-users__header-switch">
                        <Form>
                            <Form.Check 
                                type="switch"
                                id="custom-switch"
                                label={viewUsersActives ? "Usuarios Activos": "Usuarios Inactivos"}
                                defaultChecked={viewUsersActives}
                                onChange={() => setViewUsersActives(!viewUsersActives)}
                            />
                        </Form>
                    </div>

                    <Button type="primary" className="btn btn-success" onClick={addUserModal} >
                        Nuevo Usuario
                    </Button>
                </div>

                {viewUsersActives ? ( 
                        <UsersActive 
                            usersActive={usersActive} 
                            setIsVisibleModal={setIsVisibleModal} 
                            setModalTitle={setModalTitle}
                            setModalContent={setModalContent}
                            setReloadUsers={setReloadUsers}
                        /> 
                    ) : ( 
                        <UsersInactive 
                            usersInactive={usersInactive} 
                            setReloadUsers={setReloadUsers} 
                        />
                    )}

                <Modal
                    title={modalTitle}
                    isVisible={isVisibleModal}
                    setIsVisible={setIsVisibleModal}
                    setSize='lg'
                >
                    {modalContent}
                </Modal>
            </div>
        </>
    )
}

function UsersActive(props) {
    const { usersActive, setIsVisibleModal, setModalContent, setModalTitle, setReloadUsers } = props;

    const editUser = user => {
        setIsVisibleModal(true);
        setModalTitle(`Editar ${user.nombres ? user.nombres : ""} ${user.apellido_paterno ? user.apellido_paterno : ""} ${user.apellido_materno ? user.apellido_materno : ""}`);
        setModalContent(<EditUserForm user={user} setIsVisibleModal={setIsVisibleModal} setReloadUsers={setReloadUsers} />);
    }

    return (
        <>
            <div className="card shadow mb-4">
                <Table hover responsive>
                    <thead>
                        <tr>
                            <th>Avatar</th>
                            <th>Nombres</th>
                            <th>Apellido Paterno</th>
                            <th>Apellido Materno</th>
                            <th>Login</th>
                            <th>Correo</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from(usersActive.values()).map((user, index) => {
                            return <UserActive key={index} user={user} editUser={editUser} setReloadUsers={setReloadUsers} />
                        })}
                    </tbody>
                </Table>
            </div>
        </>
    )
}

function UserActive (props) {
    const {user, editUser, setReloadUsers } = props;
    const [avatar, setAvatar] = useState(null);

    useEffect(() => {
        if(user.avatar){
            getAvatarApi(user.avatar).then(response => {
                setAvatar(response);
            });
        }else{
            setAvatar(null);
        }
    }, [user]);

    const desactivateUser = () => {
        const accessToken = getAccessTokenApi();

        activateUserApi(accessToken, user._id, false).then(response => {
            setReloadUsers(true);
            successModal("", "Usuario desactivado");
        })
        .catch(err => {
            errorModal	("Error", err);
        });
    }

    const showDeleteConfirm = () => {
        const accessToken = getAccessTokenApi();

        Swal.fire({
            title: 'Eliminando usuario',
            text: "¿Estas seguro de eliminar al usuario?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Eliminar'
          }).then((result) => {
            if (result.value) {
                deleteUserApi(accessToken, user._id)
                .then(response => {
                    setReloadUsers(true);
                    successModal("",response);
                })
                .catch(err => {
                    errorModal	("Error", err);
                })
            }
          })
    }

    return (
            <tr>
                <td><Avatar src={avatar ? avatar : NoAvatar } size="50" round={true} /></td>
                <td>{user.nombres || ''}</td>
                <td>{user.apellido_paterno || ''}</td>
                <td>{user.apellido_materno || ''}</td>
                <td>{user.nm_login || ''}</td>
                <td>{user.nm_correo || ''}</td>
                <td>
                    <FontAwesomeIcon role="button" tabIndex="0" className="fas fa-pen mr-3 text-success" icon={faPen} onClick={() => editUser(user)} />
                    <FontAwesomeIcon role="button" tabIndex="0" className="fas fa-ban mr-3 text-danger" icon={faBan} onClick={desactivateUser} />
                    <FontAwesomeIcon role="button" tabIndex="0" className="fas fa-trash text-danger" icon={faTrash} onClick={showDeleteConfirm} />
                </td>
            </tr>
    )
}

function UsersInactive(props) {
    const { usersInactive, setReloadUsers } = props;

    return (
        <>
            <div className="card shadow mb-4">
                <Table hover responsive>
                    <thead>
                        <tr>
                            <th>Avatar</th>
                            <th>Nombres</th>
                            <th>Apellido Paterno</th>
                            <th>Apellido Materno</th>
                            <th>Login</th>
                            <th>Correo</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from(usersInactive.values()).map((user, index) => {
                            return <UserInactive key={index} user={user} setReloadUsers={setReloadUsers} />
                        })}
                    </tbody>
                </Table>
            </div>
        </>
    )
}

function UserInactive(props) {
    const { user, setReloadUsers } = props;
    const [avatar, setAvatar] = useState(null);

    useEffect(() => {
        if(user.avatar){
            getAvatarApi(user.avatar).then(response => {
                setAvatar(response);
            });
        }else{
            setAvatar(null);
        }
    }, [user]);

    const activateUser = () => {
        const accessToken = getAccessTokenApi();

        activateUserApi(accessToken, user._id, true).then(response => {
            setReloadUsers(true);
            successModal("",response);
        })
        .catch(err => {
           errorModal	("Error", err);
        });
    }

    const showDeleteConfirm = () => {
        const accessToken = getAccessTokenApi();

        Swal.fire({
            title: 'Eliminando usuario',
            text: "¿Estas seguro de eliminar al usuario?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Eliminar'
          }).then((result) => {
            if (result.value) {
                deleteUserApi(accessToken, user._id)
                .then(response => {
                    setReloadUsers(true);
                    successModal("",response);
                })
                .catch(err => {
                    errorModal	("Error", err);
                })
            }
          })
    }

    return (
        <>
            <tr>
                <td><Avatar src={avatar ? avatar : NoAvatar } size="50" round={true} /></td>
                <td>{user.nombres || ''}</td>
                <td>{user.apellido_paterno || ''}</td>
                <td>{user.apellido_materno || ''}</td>
                <td>{user.nm_login || ''}</td>
                <td>{user.nm_correo || ''}</td>
                <td>
                    <FontAwesomeIcon role="button" tabIndex="0" className="fas fa-check text-success mr-3" icon={faCheck} onClick={activateUser} />
                    <FontAwesomeIcon role="button" tabIndex="0" className="fas fa-trash text-danger" icon={faTrash} onClick={showDeleteConfirm} />
                </td>
            </tr>
        </>
    )
}